const appConfig = {
  contactEmail: 'info@neptunenow.com',
  supportEmail: 'support@neptunenow.com',
  productionEmail: 'production@neptunenow.com',
  domainEmail: 'emailaddress@domain.com',
  geraldEmail: 'gerald@neptunenow.com',
  exampleEmail: 'mail@example.com',
};

export default appConfig;
